import { baseApi, TAGS } from 'shared/api';
import type { BaseResponse } from 'shared/models/common';

import { EntityName } from '../model/enums';
import type { TChatMessage } from '../model/types';

type BaseChatMessageRequestParams = {
  entityId: string;
  entityName: EntityName;
};

type GetChatMessageRequestParams = BaseChatMessageRequestParams;
type DeleteChatMessageRequestParams = BaseChatMessageRequestParams & {
  chatMessageId: string;
};
type EditChatMessageRequestParams = { chatMessageId: string; message: string };

type SendMessageRequestParams = BaseChatMessageRequestParams & {
  body: {
    IsNotifyPMOnly?: boolean;
    IsShowToContactPerson?: boolean;
    Message: string;
  };
};

export const chatApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getChatMessages: build.query<TChatMessage[], GetChatMessageRequestParams>({
      query: ({ entityId, entityName }) => ({
        url: `/chats/${entityName}/${entityId}`,
        method: 'GET',
      }),
      providesTags: [TAGS.CHAT_MESSAGES],
      transformResponse: (response: BaseResponse<TChatMessage[]>) =>
        response.Data,
    }),

    markAsRead: build.mutation<void, string[]>({
      query: (ids) => ({
        url: `/user/chats/markasread`,
        method: 'PUT',
        params: {
          ids,
        },
      }),
      invalidatesTags: [TAGS.CHAT_MESSAGES],
    }),

    sendMessage: build.mutation<void, SendMessageRequestParams>({
      query: (args) => ({
        url: `/chats/${args.entityName}/${args.entityId}`,
        method: 'POST',
        body: args.body,
      }),
      invalidatesTags: (_res, error) => (error ? [] : [TAGS.CHAT_MESSAGES]),
    }),

    editMessage: build.mutation<void, EditChatMessageRequestParams>({
      query: ({ chatMessageId, message }) => ({
        url: `/user/chats/edit`,
        method: 'PUT',
        body: {
          Message: message,
        },
        params: {
          chatMessageId,
        },
      }),
      invalidatesTags: (_res, error) => (error ? [] : [TAGS.CHAT_MESSAGES]),
    }),

    deleteMessage: build.mutation<void, DeleteChatMessageRequestParams>({
      query: ({ chatMessageId }) => ({
        url: `/user/chats/delete`,
        method: 'DELETE',
        params: {
          chatMessageId,
        },
      }),
      invalidatesTags: (_res, error) => (error ? [] : [TAGS.CHAT_MESSAGES]),
    }),
  }),
});
